import 'lazysizes';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks.min';

import Slick from '@/plugins/slick';

export default {
    init() {
        Slick.init();

        document.addEventListener('lazybeforeunveil', (e) => {
            const bg = e.target.getAttribute('data-bg');
            if (bg) {
                e.target.style.backgroundImage = 'url(' + bg + ')';
            }
        });
    },
};
